import { PulseBetsTypes } from "../../../enums";

export class ViewHelper {

    private static instance: ViewHelper;

    static getInstance(): ViewHelper {
        if (!this.instance) {
            this.instance = new ViewHelper();
        }

        return this.instance;
    }

    milliToMinutesString(totalMilli: number, cutZeroMinutes?: boolean, eventTypeId?: string): string {

        let totalSecondsRounded = Math.round(totalMilli / 1000);
        if (totalSecondsRounded < 61 && cutZeroMinutes) {
            return eventTypeId === PulseBetsTypes.OneMinPulse || eventTypeId === PulseBetsTypes.ThirtySecPulse ?
                `${totalSecondsRounded}` :
                this.numToStringWithZeroPadd(totalSecondsRounded);
        }
        else {
            const minutesPart = Math.floor(totalSecondsRounded / 60);
            const secondsPart = totalSecondsRounded % 60;
            return `${this.numToStringWithZeroPadd(minutesPart)}:${this.numToStringWithZeroPadd(secondsPart)}`;
        }
    }

    milliRangeToMinutesRange(milli1: number, milli2: number, eventTypeId?: string): string {
        let smallerThanMin = (milli1 < 61000 && milli2 < 61000);
        return `${this.milliToMinutesString(milli1, smallerThanMin, eventTypeId)}-${this.milliToMinutesString(milli2, smallerThanMin, eventTypeId)}`;
    }

    private numToStringWithZeroPadd(num: number): string {
        return (num < 10) ? `0${num}` : `${num}`;
    }

}